import React, {useEffect, useState} from "react";
import {Button, Col, Modal, Row, Table,Typography} from "antd";
import './NextModalGpp.scss'
import SelectField from "components/SelectField";
import {ArrowDownIco, ArrowUpIco, ClearIco, ModalCloseIco} from "../../../../../../../modules/CustomIcons";
import {Account, getAccounts} from "../../../../../../services/account";
import {useTranslation} from "react-i18next";
import {SelectOptions} from "../../../../../../services/form";
import {getCurrentCompany} from "../../../../../../services/user";
import {financial, resetForm} from "../../../../../../services/helper";
import {Scrollbar} from "smooth-scrollbar-react";
import SuccessOrErrorModal from "components/SuccessOrErrorModal";
import {useHistory} from "react-router-dom";

const { Text } = Typography;
const NextModalGpp: React.FC<any> = (props) => {
    const {t} = useTranslation()
    const [allTables, setAllTables]=useState();
    const [totalAmount,setTotalAmount] = useState(0)
    const [totalCom,setTotalCom] = useState(0)
    const [showSuccessOrError, setShowSuccessOrError] = useState(false)
    const [modalText, setModalText] = useState<string>(props.nextModalText)
    const [popupType, setPopupType] = useState("success")
    const history = useHistory();

    const columns: any = [
        {
            title: t("businessCards.user"),
            dataIndex: 'name',
            render: (text) => <p>{text}</p>,
            maxWidth:200,
            align: 'start',
        },
        {
            title: t('home.count'),
            className: 'count',
            dataIndex: 'count',
            align: 'center',
            render:() =>
               <p>{1}</p>

        },
        {
            title:  t("common.amount")+(" (AZN)"),
            dataIndex: 'amount',
            align: 'center',
            render:(text)=>{
                if(text !==null && text !== undefined && text !== ''){
                    return   financial(text)
                }else{
                    {0.00}
                }

            }
        },
        {
            title:t("home.commission")+(" (AZN)"),
            dataIndex: 'COMMAMOUNT',
            align: 'center',
            render:(text)=>{
               return financial(text)
            }
        },


    ]

    const columnsFooter:any = [
        {
            dataIndex:'sum',
            className:'sum',
            render:()=>
                <p>{t("credits.total")}</p>

        },
        {
            title: t('home.count'),
            className: 'count',
            dataIndex: 'count',
            align: 'start',
            // render:(text,record)=> {}
                // <p>{record.length}</p>



        },{
            title: t("common.amount")+(" (AZN)"),
            dataIndex: 'amount',
            align: 'start',

        },
        {
            title:t("home.commission")+(" (AZN)"),
            dataIndex: 'COMMAMOUNT',
            align: 'start',

        },
    ]

    const showSuccessModal = () => {
        setShowSuccessOrError(old_status => true);
        if (props.currentForm) {
            resetForm(props.currentForm)
        }
    }

    const sendTransactionRequest = async (totalAmount: any, totalCom: any) =>
    {
        props.callBackApi(totalAmount, totalCom).then((res)=>{
            if (res?.status === "SUCCESS" || res?.resultMessage === "SUCCESS") {

                // props.onClose((old_value) => false)
                setModalText(t('notification.transfersCreated'));
                setPopupType('success');
                showSuccessModal();
            }else{
                setShowSuccessOrError(true)
                setModalText(t("notification.errorOccured"));
                setPopupType('error');
            }
        }).catch((e) => {

            setShowSuccessOrError(true)
            setPopupType("error")
            setModalText(t("notification.errorOccured"))
        })
    }

    const onClose = () => {
        props.onClose((old_value) => false)
    }

    const onCloseSuccessModal = () => {

        if (props.onCloseSuccessModal !== null && props.onCloseSuccessModal !== undefined) {
            props.onCloseSuccessModal((old_value) => false)
        }
        if(props.onOktransfer){
            props.onOktransfer('',true,'')
        }

        props.onClose((old_value) => false)
        setShowSuccessOrError(false)
     
        /*setTimeout(() => {
          window.location.reload();
        }, 500)*/
    }

    const customFooter =() =>(
        <>
            <div style={{ marginTop:-65 }}>
                <Table
                    className={'gpptransfer_table nextModal_table'}
                    style={{margin:'30px 30px 20px 30px'}}
                    columns={columnsFooter}
                    summary={(data)=>{
                        let totalAmount = 0;
                        let totalCom = 0;
                        let totalTRN=0
                        props.data.map((row)=>{
                            row.paymentRow.map((item) =>
                            {
                                totalTRN+=1
                                if (typeof item.amount === 'string') {
                                    totalAmount += Number(item.amount);
                                    setTotalAmount(totalAmount)
                                } else {
                                    totalAmount += item.amount;
                                    setTotalAmount(totalAmount)
                                }
                                totalCom += item.COMMAMOUNT;
                                setTotalCom(totalCom)
                            })
                        });
                        return (
                            <>
                                <Table.Summary.Row>
                                    <Table.Summary.Cell className={'total'} index={0}>{t("credits.total")}</Table.Summary.Cell>
                                    <Table.Summary.Cell className={'summary'} index={1}>
                                        <Text >{totalTRN}</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell className={'summary'} index={2}>
                                        <Text >{financial(totalAmount)}</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell className={'summary'} index={3}>
                                        <Text>{financial(totalCom)}</Text>
                                    </Table.Summary.Cell>
                                </Table.Summary.Row>

                            </>
                        );
                    }}
                    // onExpand={onExpand}
                    // expandedRowKeys={expandedKeys}

                />
            </div>
            <div className={"flex justify_between align_center"}>
                <Button onClick={onClose} type={'button'} className={'light-button back_btn refresh_btn next_modal_cancel_btn btn flex align_center justify_center'}>
                    {t('templates.back')}
                </Button>
                <Button type={"button"}
                        onClick={()=>sendTransactionRequest(totalAmount,totalCom)}
                        className={'create-btn green--btn'}>

                    {t('salary.createTransfer')}
                </Button>
            </div>
        </>


    )

    const customPlaceholder =(
        <div style={{width:410}} className={'flex justify_between'}>
          <p style={{color:"#223142"}}>{props.value.NICKNAME!==undefined?props.value.NICKNAME:props.value.IBAN}</p>
            <p style={{color:"#015CD1"}}>{financial(props.balance)} AZN</p>
        </div>
    )

    return (
        <>
            <Modal
                open={props.visible}
                title={t("transfers.paymentInfo")}
                footer={customFooter()}
                closeIcon={<ModalCloseIco />}
                centered
                onCancel={onClose}
                style={{minHeight:480}}
                width={760}

            >

                    <Col className={'gpp_fromacc gpp_nextselect gppheader'} span={18} style={{marginLeft:30,marginTop:20 }}>
                        {/*{console.log(props.value)}*/}
                        <SelectField
                            labelItem={t("transfers.fromAccount")}
                            placeholder={customPlaceholder}
                            // defaultValue={props.value}
                            name={'CUSTACC'}
                            disabled={true}
                            // required={true}
                            // form={form}
                            // notFoundContent={!loadingAccount ? t("newTransfer.noAccountCorrespondingCurrency") : undefined }
                        />
                    </Col>
                <>
                    <Scrollbar
                        plugins={{
                            overscroll: {
                                effect: 'glow',
                            },
                        }}
                        alwaysShowTracks={true}
                    >


                            <Col style={{maxHeight:400}}>
                                {
                                    props.data.map((line:any,index:number) => {
                                        return   <Table
                                            pagination={false}
                                            className={'gpptransfer_table nextgpp_table'}
                                            style={{margin: '30px 23px 20px 30px'}}
                                            columns={columns}
                                            dataSource={line.paymentRow}
                                            // onExpand={onExpand}
                                            // expandedRowKeys={expandedKeys}

                                            title={() => line.paymentTitle}
                                        />

                                    })
                                }

                            </Col>



                    </Scrollbar>
                </>

            </Modal>
            {showSuccessOrError && (
                <SuccessOrErrorModal
                    visible={true}
                    onOk={props.onOk}
                    modalType={popupType}
                    modalTitle={popupType === 'success' ? t("home.transfer") : t("notification.attention")}
                    modalText={modalText}
                    onClose={() => { onCloseSuccessModal(); onClose() }}
                />
            )}
        </>
    )
}
export default NextModalGpp